import { workspaceNavigation } from '../../navigation/workspaceAssistantNavigation';
import type { Screen } from '../../contexts/AppContext';
import type { SearchTarget } from './searchTypes';

/**
 * A search result's target → navigateTo arguments, through the assistant's reviewed route rules
 * (known screens, ObjectId params, allowed settings panels). `q` pre-fills the list screen's search.
 */
export function searchNavigation(target: SearchTarget): { screen: Screen; param?: string; routeParams?: Record<string, string> } | null {
  const param = target.param === 'default' ? undefined : target.param;
  const nav = workspaceNavigation({ id: target.screen, label: '', screen: target.screen, ...(param ? { param } : {}), ...(target.settingsItem ? { settingsItem: target.settingsItem } : {}) });
  if (!nav) return null;
  const q = typeof target.q === 'string' ? target.q.trim().slice(0, 120) : '';
  return q ? { ...nav, routeParams: { ...(nav.routeParams || {}), q } } : nav;
}
